import script from "./NextDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NextDetail.vue?vue&type=script&setup=true&lang=js"

import "./NextDetail.vue?vue&type=style&index=0&id=2da19ff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da19ff8"]])

export default __exports__